import React from 'react';
// logic
import useTicketFormSettings from '../components/ticketForm/useTicketFormSettings';
import { useParams } from 'react-router-dom';
// components
import PortalContent from '../components/ui/portal/portalContent';
import TicketForm from '../components/ticketForm/ticketForm';
import BasicLoader from '../components/ui/loaders/basicLoader';
import TicketRepeatToolbar from '../components/ticketRepeat/ticketRepeatToolbar';
import useTicketRepeat from '../components/ticketRepeat/useTicketRepeat';
import PremiumSectionContainer from '../components/ticketForm/components/PremiumSectionContainer';
import PremiumSection from '../components/ticketForm/components/PremiumSection';
import { InfoMessage } from '../components/ticketForm/components/InfoMessage';

const TicketRepeatPage = ({ ...props }) => {
  const { id } = useParams();
  const { isLoadingTicketFormSettings, ticketFormSettings } = useTicketFormSettings();
  const {
    ticketDetail,
    isLoadingTicketDetail,
    ticketDetailError,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
  } = useTicketRepeat({ id });

  const ticketFormData = {
    ticketFormSettings,
    validationSchema,
    initialValues,
    ticketDetail,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
  };

  const isPageReady = !isLoadingTicketDetail && !isLoadingTicketFormSettings;
  const is404Error = ticketDetailError?.code === 404;

  return (
    <>
      <PortalContent>
        <TicketRepeatToolbar id={id} />
      </PortalContent>
      {!isPageReady ? (
        <BasicLoader />
      ) : ticketDetailError ? (
        <PremiumSectionContainer>
          <PremiumSection>
            <InfoMessage>
              {is404Error ? 'Ticket not found' : 'There was an error loading the ticket'}
            </InfoMessage>
          </PremiumSection>
        </PremiumSectionContainer>
      ) : (
        <TicketForm ticketFormData={ticketFormData} />
      )}
    </>
  );
};

export default TicketRepeatPage;
